// extracted by mini-css-extract-plugin
module.exports = {"mainWidgetPage":"_2-Dg_4ZiHMcHW9whTJGXKy","mainWidgetPageSpinner":"_2y0xdIJE941Mru4LqDWciK"};